import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useTranslation } from "react-i18next";
import SectionContainer from "../../../@GeneralComponents/SectionContainer";

const renderCheckboxRow = (key, label, checked, onChange) => (
  <div style={{ marginLeft: "12px" }} key={key}>
    <FormControl component="fieldset">
      <FormGroup aria-label="position" column="true">
        <FormControlLabel
          style={{ alignItems: "center" }}
          control={
            <input
              style={{ minWidth: "18px", minHeight: "18px", margin: "8px 0px" }}
              type="checkbox"
              checked={checked}
              onChange={(event) => onChange(event.target.checked)}
            />
          }
          label={
            <div style={{ alignItems: "center", margin: "4px" }}>
              <span className="normalText normalMediumSize">{label}</span>
            </div>
          }
        />
      </FormGroup>
    </FormControl>
  </div>
);

const SubgroupHeader = ({ title, description }) => (
  <div style={{ margin: "12px 0 4px 12px" }}>
    <div className="normalText normalMediumSize bold">{title}</div>
    {description && (
      <div className="labelText normalSmallSize">{description}</div>
    )}
  </div>
);

const CompanyKeysSection = ({
  companies,
  isLoading,
  selectedCompanyKeys,
  onToggle,
  onSelectAll,
  managerRoleChecked,
  onToggleManagerRole,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const allChecked = selectedCompanyKeys.length === 0 || selectedCompanyKeys.length === companies.length;

  return (
    <SectionContainer
      sectionClasses="internalSectionContainer"
      sectionTitle={t("user_company_keys")}
      sectionTitleStyle={{ fontWeight: "400" }}
      sectionSubtitle={t("user_company_keys_description")}
      sectionSubtitleClassName="labelText normalSmallSize"
      isCollape={true}
      collapeState={expanded}
      collapeStateHandler={() => setExpanded((prev) => !prev)}
    >
      <SubgroupHeader
        title={t("user_company_keys_manager_role")}
        description={t("user_company_keys_manager_role_description")}
      />
      {renderCheckboxRow(
        "manage_business_group_user_company_keys",
        t("grant_manage_company_keys_role"),
        managerRoleChecked,
        (checked) => onToggleManagerRole(checked)
      )}

      <div style={{ borderTop: "1px solid #e5e5e5", margin: "12px 0 0 0" }} />

      <SubgroupHeader
        title={t("user_company_keys_access_subgroup")}
        description={t("user_company_keys_access_subgroup_description")}
      />
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
          <CircularProgress size={24} />
        </div>
      ) : companies.length === 0 ? (
        <div className="labelText normalSmallSize" style={{ marginLeft: "12px" }}>
          {t("no_companies_available")}
        </div>
      ) : (
        <>
          {renderCheckboxRow("__all__", t("all"), allChecked, () => onSelectAll())}
          {companies.map((company) =>
            renderCheckboxRow(
              company.company_key,
              company.name || company.legal_name || company.company_key,
              !allChecked && selectedCompanyKeys.includes(company.company_key),
              () => onToggle(company.company_key)
            )
          )}
        </>
      )}
    </SectionContainer>
  );
};

export default CompanyKeysSection;
